import { Route, Routes } from 'react-router-dom'
import EnrollmentsPage from './Page'

export default function Enrollments() {
  return (
    <Routes>
      <Route path="/*" element={<EnrollmentsPage />} />
      <Route path="/:details" element={<EnrollmentsPage />} />
    </Routes>
  )
}
